import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { ShareObjectsController } from '@commoncore/controller/ShareObjectsController';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { GlobalService } from '@commoncore/services/global.service';
import { RecipientAccess, RecipientOperations, ShareAccessRole, ShareType } from '@commoncore/services/universal.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { EnterpriseController } from 'projects/enterprise/src/app/core/controller/EnterpriseController';
import { debounceTime } from 'rxjs/operators';
@Component({
  standalone:true,
  selector: 'app-private-share',
  templateUrl: './private-share.component.html',
  styleUrls: ['./private-share.component.scss'],
  imports:[DependenciesModule]
})
export class PrivateShareComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() setShare = new EventEmitter();
  universalService: any;
  listService:any;
  ownerDetail:any;
  controller: any;
  implRef: any;
  showSharePopUp:boolean = false;
  copyText : string = "Copy Link";
  maximize : boolean = true;
  selectedTag: any;
  fileopsctrl: any;
  suggestedEmails: any;
  suggestedContacts: any;
  suggestedContactList: any = [];
  userAccessRole:any = ["V", "E", "R"];
  sharedFileRecipientsList: any;
  emailList: any = [];
  userLoginController: any;
  loginImplRef: any;
  localStorageService: any;
  shareAccessService: any;
  cleverTapEventsService:any;
  showShareWithPeople:any;
  inAppWebViewService:any;
  isIOSDevice:boolean;
  isUserPermissionChanged:boolean = false;
  contactControl = new FormControl();
  userData:any;
  isLoggedInUserAllowedToEdit:boolean = false;
  containerHeightCalc:any;
  suggestedEntUsers: any;
  entImplRef: any;
  entController: any;
  openSourceComponent:any = "";
  private htmlAndDoctypeRegex = /<\/?[a-z][\s\S]*?>|<!DOCTYPE[^>]*>/gi;
  private urlRegex = /https?:\/\//gi;
  private lineBreakRegex = /[\r\n]+/g;
  constructor(private globalService:GlobalService, private cdRef :ChangeDetectorRef) {
    this.setEnvObjects(this.globalService);
  }

  ngOnInit(): void {
    var classRef = this;
    this.controller=ShareObjectsController.getInstance(this.globalService);
    this.controller.setEnvObjects(this.globalService);
    this.implRef = this.controller.shareObjectsImplementation;
    this.fileopsctrl = this.controller.fileOpsController;
    this.userLoginController = UserloginController.getInstance(this.globalService);
    this.loginImplRef = this.userLoginController.userLoginImplementation;
    this.userData = this.localStorageService.getUserData(true);
    this.isIOSDevice = this.inAppWebViewService.checkiOSdevice();
    this.implRef.setHandler(this.globalService);
    this.subscriptionToShareEvent();
    this.initializeSearch();
  }

  subscriptionToShareEvent(){
    let classRef = this;
    
    AppEvents.optionSelected.subscribe(event => {
      console.log("shareWithPeople", event)
      if(event["shareWithPeople"]){
        if(event["openSource"] == "fileinfo"){
          this.openSourceComponent = event["openSource"];
        }
        classRef.showShareWithPeople = event["shareWithPeople"];
				classRef.universalService.popUpToBeOpened = "dummy"; 
        classRef.initializeComponent();
        classRef.cdRef.detectChanges();
      } else if(event["closeAll"] || event["shareWithPeople"] == false){
        classRef.showShareWithPeople = false;
        classRef.suggestedContactList = [];
        if(jQuery('#collapseOne').hasClass('show')) {
          jQuery('h2').trigger("click");
        }
        if(this.openSourceComponent == "fileinfo") {
          AppEvents.optionSelected.next({fileInfo: true, openSource: this.openSourceComponent});
          this.universalService.showObjectInfo(this.universalService.selectedFile);
          if(!this.universalService.isAnyChange)
            $('#custome_backdrop').remove();
          else 
            this.openSourceComponent = "";
        }
        //classRef.listService.deSelectAll("");
        this.cdRef.detectChanges();        
      }
    })
  }


  initializeComponent() {
    // AppEvents.optionSelected.next({shareWithPeople: false});
    this.implRef.resetDefaultProperties();
    this.checkIfUserIsLoggedIn();
    this.universalService.showMobOptionMenu = false;

    // AppEvents.optionSelected.next({shareWithPeople: false});
    if(this.universalService.selectedFile.shareKey != undefined ) { //removed shareLink check, as we don't get it for InheritedShare objects (as per server)
      this.implRef.shareKey = this.universalService.selectedFile.shareKey;
      this.implRef.shareLink = this.universalService.selectedFile.shareLink;
      this.getRecipientsList();
    } else {
      this.implRef.sharedWithNamesLink = "Not Shared yet";
      this.ownerDetail = this.userData.firstName + " " + (this.userData.lastName ? this.userData.lastName : "");
      jQuery(".bottom-aligned").show();
    }
    this.universalService.showModalBackdrop();
    this.openNav();

    setTimeout(() => {
      $('#contact-input').val('');  
    }, 100);
    jQuery(document).off('focusin.modal');
    this.checkLoggedInUserAllowedToEdit();
  }

  checkLoggedInUserAllowedToEdit() {
    var url = window.location.href;
    if(url.includes("/shared/") || this.universalService.inAppWebViewOpened){
      this.isLoggedInUserAllowedToEdit = (this.universalService.selectedFile?.shareKey?((this.universalService.selectedFile?.recipientsObjRights && this.universalService.selectedFile.recipientsObjRights.canEdit)? true : false):true)
    } else {
      this.isLoggedInUserAllowedToEdit = true;
    }
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.inAppWebViewService = globalService.getInAppWebviewService();
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
  }
  
  attachKeysToPhoto(photoPath) {
    let type = this.universalService.checkIfImgTypeParamIsRequired("");
    return 'url('+photoPath + '&apiKey=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]['X-Api-Key'] + type +')';
  }
  getRoleNameFromCode(roleCode) {
    var roleMapping = {
        "V" : RecipientAccess.V,
        "E" : RecipientAccess.E,
        "R" : RecipientAccess.R
      }
    return roleMapping[roleCode]
  }

  async getRecipientsList() {
    var shareOwner:any;
    this.sharedFileRecipientsList = [];
    this.implRef.displayList = [];
    this.implRef.toggleSmallLoader(true);
    var membersList = await this.controller.getSharedFileMembers(this.universalService.selectedFile.shareKey);
    if(membersList != null) {
      this.implRef.setMembersLink(membersList);
      //this.sharedFileRecipientsList = membersList["shareRecipients"];
      this.implRef.displayList = membersList["shareRecipients"].filter(function (recipient) { // Filter data, ignore owner role 
        return recipient.recipientRole != 'O';
      });
      //Get owner info
      shareOwner = membersList["shareRecipients"].filter(function (recipient) { // Filter data with owner role 
        return recipient.recipientRole == 'O';
      });
      this.ownerDetail = (shareOwner.length != 0)? shareOwner[0].firstName + " " + (shareOwner[0].lastName ? shareOwner[0].lastName : "") : '';
      // this.universalService.showManageAccess = true;

      if(membersList["shareType"] != undefined) {
        this.implRef.shareType = membersList["shareType"];
      } else {
        this.implRef.shareType = ShareType.RESTRICTED;
      }

      if(membersList["shareAccessRole"] != undefined) {
        this.implRef.shareAccessRole = membersList["shareAccessRole"];
      }
  
      this.updateShareDataObjects();
    } else {
      this.ownerDetail = this.userData.firstName + " " + (this.userData.lastName ? this.userData.lastName : "");
      this.implRef.sharedWithNamesLink = "Not Shared yet";
    }
    this.implRef.toggleSmallLoader(false);
    jQuery(".bottom-aligned").show();
  }

  addNewRecipientMobile(e,emailId) {
    console.log("addNewRecipientMobile")
    if(!this.universalService.isMobileDevice){
      return
    }
    var lastChar = emailId[emailId.length-1];
    console.log("event",e)
    if(lastChar == " " || lastChar == "," || e.which == 13) {
      var contact = $('#contact-input').val();
      if(lastChar == " " || lastChar == "," )
        emailId = emailId.replace(lastChar,"");
        contact = emailId;
        this.getSelectedContact(contact);
    }
  }

  addNewRecipientDesktop(e,emailId) {
    console.log("addNewRecipientDesktop")
    if(this.universalService.isMobileDevice){
      return
    }
    if(e.code == "Comma" || e.code == "Space" || e.code == "Enter") {
      var contact = $('#contact-input').val();
      this.getSelectedContact(contact);
    }
  }


  onAddingRecipient() {
    console.log("onAddingRecipient")
    let contact = $('#contact-input').val() as any;
    if(contact.trim() == "") {
      this.implRef.mailError.error = "";
      this.implRef.invalidEmailIDorNum = [];
      if(this.implRef.displayList.length == 0) {
        this.universalService.isAnyChange = false;
      } else {
        this.universalService.isAnyChange = true;
      }
    }
  }

  removeNewRecipient(recipient) {
    this.implRef.displayList = this.implRef.displayList.filter(function(item) { 
      return item.recipientId !== recipient;  
   });
   if(this.implRef.displayList.length == 0) {
     this.universalService.isAnyChange = false;
   }
   console.log(this.implRef.displayList);
  }

  async getSuggestedEmailList() {

    this.implRef.toggleSmallLoader(true);
    this.suggestedEmails = await this.fileopsctrl.getSuggestedEmails();
    this.suggestedEmails.contactEmail.map(item =>{
      this.emailList.push(item.email)
    })
    this.implRef.toggleSmallLoader(false);
  }

  async getEntSearchedUsers(searchKey) {
    this.entController = EnterpriseController.getInstance(this.globalService);
    this.entController.setEnvObjects(this.globalService);
    this.entImplRef = this.entController.dashboardImplementation;
    if ( !this.entImplRef.searchValidation(searchKey)) {
      this.suggestedEntUsers = [];
      return;
    }
    this.implRef.toggleSmallLoader(true);
    this.suggestedContacts = await this.entController.getSearchedUserData(searchKey, "share");  
    if(this.suggestedContacts != null && this.suggestedContacts.length != 0) {
      this.suggestedContactList = [];
      this.suggestedContacts.map(item =>{
        this.suggestedContactList.push(item);
      })

    } else {
      this.implRef.toggleSmallLoader(false);
      this.implRef.contactChunk = [];
      this.suggestedContactList = [];
    }
    console.log("ent share search",this.suggestedContactList);
    this.implRef.toggleSmallLoader(false);
  }

  async getSyncedContacts(searchKey) {
    if(this.universalService.isAllowEnternalPrivateShare == true || this.universalService.isAllowExtPrivateShare == true){
      await this.getEntSearchedUsers(searchKey);
    }else {
      if (!this.implRef.searchContactValidation(searchKey)) {
        this.suggestedContactList = [];
        return;
      }
      this.implRef.toggleSmallLoader(true);
      this.suggestedContacts = await this.controller.getSuggestedContacts(searchKey);
      if(this.suggestedContacts != null && this.suggestedContacts.contacts.length != 0) {
        this.implRef.parseContacts(this.suggestedContacts.contacts, searchKey);
        this.suggestedContactList = [];
        this.implRef.contactChunk.map(item =>{
          this.suggestedContactList.push(item.display);
        })
      } else {
        this.implRef.toggleSmallLoader(false);
        this.implRef.contactChunk = [];
        this.suggestedContactList = [];
      }
      console.log("normal share search",this.suggestedContactList);
      this.implRef.toggleSmallLoader(false);
    }
  }

  async sendCollabShareLinkToSelectedRecipients(){
    var msg = "";
    this.cleverTapEventsService.privateShareSave();
    //If existing shared files, then update, else post new data
    if(!this.universalService.selectedFile.shareKey) {
      this.implRef.selectedContact = this.implRef.displayList.map(obj => ({...obj}));
      this.implRef.selectedContact.forEach(function(v){ delete v.isNewRecipient });
      var apiResponse = await this.controller.createCollabShareLinkForSelectedObjects(this.universalService.selectedFile);
      this.showAddPeopleError(apiResponse);
    } else {
      var newlyAdded = [];
      //this.implRef.selectedContact = this.implRef.modifiedRecipientsList;

      //send api call if permission changed//added new members
      if(this.isUserPermissionChanged == true || this.universalService.isAnyChange) {
        if(this.implRef.displayList.length > 0) {
          // this.implRef.selectedContact = this.implRef.displayList.filter(function(itm){
          //   return ('isNewRecipient' in itm);
          // });
          newlyAdded = this.implRef.displayList.filter(function(itm){
            return ('isNewRecipient' in itm);
          });
          this.implRef.selectedContact = [...this.implRef.modifiedRecipientsList, ...newlyAdded];
          this.implRef.selectedContact.forEach(function(v){ delete v.isNewRecipient });
        }
        
        var updateResp = await this.controller.updateCollabShareForSelectedObjects();
        if (updateResp.error) {
          this.implRef.toggleSmallLoader(false);
          if (updateResp["error"]['code'] != "NMSCL0021" && updateResp["error"]['code'] != "NMSCL0024" && updateResp["error"]['code'] != "NMSAD0002" ) {
            this.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
          }else if(updateResp["error"]['code'] == "NMSAD0002" ){
            this.universalService.showToast(updateResp["error"]['error'],"error");
          }
          return false;
        } else {
          this.implRef.setShareObjects(updateResp);
        }
        this.implRef.toggleSmallLoader(false);
        this.universalService.showToast(TOAST["CHANGES_SAVED"], "success");

        this.closeNav();
      } else {
        this.closeNav();
      }
    }

    // $(".pointer").prop('disabled', true);
  }

  showAddPeopleError(apiResponse) {
    if (apiResponse.error) {
      this.implRef.toggleSmallLoader(false);
      if (apiResponse["error"]['code'] != "NMSCL0021" && apiResponse["error"]['code'] != "NMSCL0024" && apiResponse["error"]['code'] != "NMSAD0002" && apiResponse["error"]['code'] != "NMSCL0202") {
        this.universalService.showToast(TOAST["GENERIC_ERROR"], "error");
        $(".pointer").prop('disabled', false);
      }else if(apiResponse["error"]['code'] == "NMSAD0002" || apiResponse["error"]['code'] == "NMSCL0202"){
        this.universalService.showToast(apiResponse["error"]['error'],"error");
        $(".pointer").prop('disabled', false);
      }
      return false;
    } else {
      this.showAddPeopleOperation(apiResponse);
    }
  }

  showAddPeopleOperation(apiResponse) {
    var msg = "";
    this.implRef.setShareObjects(apiResponse);
    this.setShare.emit(this.universalService.selectedNodes);
    if(this.implRef.selectedContact.length != 0) {   
      msg = TOAST["ADD_PEOPLE_SUCCESS"];
    } else {
      msg = TOAST["CHANGES_SAVED"];
    }
    if((this.universalService.inAppWebViewOpened && this.universalService.currentTab != 'addpeople') || !this.universalService.inAppWebViewOpened) {
    this.universalService.showToast(msg, "success")
    }
    this.cleverTapEventsService.onShareSendClick();
 
    this.implRef.resetDefaultProperties();
    if(this.universalService.currentTab == 'addpeople' && this.universalService.inAppWebViewOpened){
      this.universalService.currentTab = "";
    }
    this.listService.deSelectAll(msg);
    this.confirmDiscard();
  }

  updateShareDataObjects() {
    //Updating ShareType for link access
    if(this.implRef.shareType == ShareType.RESTRICTED) {
      this.implRef.isLinkRestricted = true;
    } else {
      this.implRef.isLinkRestricted = false;
    }

    if(this.implRef.shareAccessRole == ShareAccessRole.EDITOR) {
      this.implRef.isShareAccessRoleViewer = false;
    } else {
      this.implRef.isShareAccessRoleViewer = true;
    }

  }

  toggleUserAccessMenu() {
    jQuery(".flyout-main").toggle();
  }

  onFocusOutEvent(){
    jQuery(".flyout-main").attr("style", "display:none")
  }

  handleLinkAccessSwitch(event) {
    var currentElement = event.target.className;
    if(currentElement.indexOf("active") != -1) {
      return false;
    }
    this.cleverTapEventsService.onShareViewerEditorToggleClick();
    if(event.target.dataset.linkPublic == "false") {
      this.implRef.shareAccessRole = ShareAccessRole.EDITOR;
      this.implRef.isShareAccessRoleViewer = false;
    } else {
      this.implRef.shareAccessRole = ShareAccessRole.VIEWER;
      this.implRef.isShareAccessRoleViewer = true;
    }
    this.implRef.validateCollabShareObject("shareAccessRole");
    console.log("collabShareObject::" + this.universalService.collabShareObject);
  }

  handleLinkAccess(event) {

    if(event.target.dataset.linkRestricted == this.implRef.isLinkRestricted.toString()) {
      return false;
    }

    if(event.target.dataset.linkRestricted == "false") {
      this.implRef.isLinkRestricted = false;
      this.implRef.shareType = ShareType.PUBLIC;
      this.cleverTapEventsService.onShareAnyoneWithLinkClick();
    } else {
      this.implRef.isLinkRestricted = true;
      this.implRef.shareType = ShareType.RESTRICTED;
      this.cleverTapEventsService.onShareRestrictedClick();
    }

    this.implRef.validateCollabShareObject("shareType");
    console.log("collabShareObject::" + this.universalService.collabShareObject);

    this.toggleUserAccessMenu();
  }

  ngOnDestroy(){
    jQuery("[class*='modal-backdrop']").remove();
  }

  openNav() {
    if(!this.universalService.inAppWebViewOpened) {
      jQuery(".add-people-panel").animate({"right":"0"}, "400");
    } else {
      jQuery(".add-people-panel").css({"right":"0"});
    }
  }

  closeNav() {
    var classRef = this;
    if(jQuery('#collapseOne').hasClass('show')) {
      jQuery('h2').trigger("click");
    }
    jQuery(".add-people-panel").animate({"right":"-1000px"}, "400");
    this.suggestedContactList = [];
    this.isLoggedInUserAllowedToEdit = false;
    this.ownerDetail = "";
    this.universalService.disableModalBackdrop();
    setTimeout(function(){
      classRef.universalService.showShareWithPeople = false;
    }, 500);
    if(this.openSourceComponent) {
      this.openSourceComponent = false;
      AppEvents.optionSelected.next({fileInfo: true});
      this.universalService.showObjectInfo(this.universalService.selectedFile);
    }
    this.implRef.resetDefaultProperties();
  }

  confirmDiscard() { 
    //Added this change for 'isBackPressed'
    if(this.universalService.collabShareObject.length == 0 && !this.universalService.isAnyChange) {
      if(!this.universalService.inAppWebViewOpened){
        this.listService.deSelectAll();
      }else{
        this.listService.objectDetails["operationType"] = "addpeople";
        if(this.universalService.showShareWithPeople){
          AppEvents.optionSelected.next({shareWithPeople: false});
          this.closeNav();
          return
        }
        this.listService.informAndroidAndIOSToCloseWebView("")
      }
      this.closeNav();
    } else {
      setTimeout(()=>{
        if(this.universalService.popUpToBeOpened == 'shareDiscardPopUp'){
          let ele = document.querySelector('.add-people-panel') as any
          ele.style.zIndex = '9999';
          this.universalService.showModalBackdrop();
          this.universalService.popUpToBeOpened = '';
        }else{
          let ele = document.querySelector('.add-people-panel') as any
          ele.style.zIndex = '999';
          this.universalService.showModalBackdrop();
          this.universalService.popUpToBeOpened = 'shareDiscardPopUp';
        }
        
      },100)
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if(this.showShareWithPeople) {
      if (event.key === "Escape" && !this.universalService.loadManageAccessComponent && !$('#myAlbumSidenav').is(':visible')) {
          this.confirmDiscard();
      }else if(window.location.href.indexOf('/albums')<0 && event.key === "Enter" && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA" && this.universalService.isAnyChange && this.implRef.receiverIds.length>0 && this.universalService.popUpToBeOpened != 'shareDiscardPopUp'){
        console.log("focus tag::", document.activeElement.tagName);
        this.sendCollabShareLinkToSelectedRecipients();
      }
    }
  }

  validateComments(senderMessage){
    const sanitizedMessage = senderMessage.value
    .replace(this.htmlAndDoctypeRegex, '')
    // .replace(this.urlRegex, '') 
    .replace(this.lineBreakRegex, ' ');    
    senderMessage.value = sanitizedMessage;
    this.implRef.validateComments(senderMessage.value);
  }

  async copyLink() {
    this.implRef.isCopyLink = true;
    
    if(!this.implRef.isCollabShareLinkPresent()) {
      var apiResponse = await this.controller.createCollabShareLinkForSelectedObjects(this.universalService.selectedFile);
      this.implRef.setShareObjects(apiResponse);
      this.copyShareText();
    } else if(this.universalService.selectedFile.shareLink == undefined || this.universalService.collabShareObject.length > 0) {
      this.implRef.shareKey = this.universalService.selectedFile.shareKey;
      var apiResponse = await this.controller.updateCollabShareForSelectedObjects();
      if(apiResponse != null) {
        this.implRef.setShareObjects(apiResponse);
        this.copyShareText();
        this.universalService.collabShareObject = [];
        this.universalService.showModalBackdrop();
      }
    } else {
      this.copyShareText();
    }
  }

  copyShareText() {
    var self = this;
    this.implRef.isCopyLink = false;
    this.setShare.emit(this.universalService.selectedNodes);

    if(self.universalService.inAppWebViewOpened && !self.isIOSDevice) {
      const el = document.createElement("input");
      document.body.appendChild(el);
      el.value = self.implRef.shareLink;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      self.copyText = "Copied"
      setTimeout(() => {
        self.copyText = "Copy Link"
      }, 3000);
    } else {
      self.universalService.showLoader = true;
  
      setTimeout(function() {
        navigator.clipboard.writeText(self.implRef.shareLink).then(function() {
          /* clipboard successfully set */
          self.universalService.showLoader = false;
          self.copyText = "Copied";
          setTimeout(() => {
            self.copyText = "Copy Link";
          }, 3000);
        }, function() {
          /* clipboard write failed */
          self.universalService.showLoader = false;
          self.universalService.showToast(TOAST["COPY_LINK_FAILURE"], "error");
        });
        self.cleverTapEventsService.onShareCopyLinkClick();
      });
    }
  }

  openManageAccessView() {
    if(this.implRef.sharedFileRecipientsList != undefined && this.implRef.sharedFileRecipientsList.length > 0) {
      this.universalService.loadManageAccessComponent = true;
      jQuery(".manage-access-panel").fadeIn();
    }
  }

  closeManageAccessView() {
    jQuery(".manage-access-panel").fadeOut();
  }

  checkIfUserIsLoggedIn(){
    this.userData = this.localStorageService.getUserData(true);
    var nativeHeaders = this.localStorageService.getNativeHeaders('nativeHeaders');
		if (this.userData) {      
      this.universalService.userLoggedIn = true;
      AppEvents.updateAuthData.next({"updateAuthData":true,userData:this.userData});
		}else if (nativeHeaders){
      this.universalService.userLoggedIn = true;
      this.universalService.inAppWebViewOpened = true;
    } else {
		  this.universalService.userLoggedIn = false;
		}
  }

  explicitUserPermission(event,recipientId, recipientKey,recipient) {
    this.cleverTapEventsService.privateSharePermissionChanges();
    $(event.target).parent().siblings().html(this.getRoleNameFromCode(event.target.dataset.accessRole) + '<span class="chevron"></span>');
    var indexFound = this.implRef.modifiedRecipientsList.findIndex(recipient => recipient.recipientId == recipientId);
    this.implRef.displayList.map(item=>{
      if(item.recipientId == recipientId) {
        //item.recipientRole = (event.target.dataset.accessRole == "R") ? undefined : event.target.dataset.accessRole;
        item.recipientRole = event.target.dataset.accessRole;
      }
    });
    if(indexFound != -1) {
      if(this.implRef.modifiedRecipientsList[indexFound]["recipientRole"] != event.target.dataset.accessRole) {
        this.implRef.modifiedRecipientsList[indexFound]["recipientRole"] = (event.target.dataset.accessRole == "R") ? undefined : event.target.dataset.accessRole;
        if(event.target.dataset.accessRole == "R") {
          this.implRef.modifiedRecipientsList[indexFound]["operation"] = RecipientOperations.REMOVE;
        } else {
          this.implRef.modifiedRecipientsList[indexFound]["operation"] = RecipientOperations.UPDATE;
        }
        this.isUserPermissionChanged = true;
      }
    } else {
      if(recipientKey == undefined && event.target.dataset.accessRole == "R") { //If new entry, delete from list on REMOVE
        this.removeNewRecipient(recipientId);
      }
      if(recipientKey != undefined) {
        this.implRef.modifiedRecipientsList.push(
          {
            recipientId : recipientId,
            recipientRole : (event.target.dataset.accessRole == "R") ? undefined : event.target.dataset.accessRole,
            recipientKey : recipientKey,
            operation : (event.target.dataset.accessRole == "R") ? RecipientOperations.REMOVE : RecipientOperations.UPDATE
          }
        );
      }
      this.isUserPermissionChanged = true;
    }
    if(event.target.dataset.accessRole == "R" && this.implRef.displayList.length == 0) {
      this.universalService.isAnyChange = false;
    } else {
      this.universalService.isAnyChange = true;
    }
  }

  initializeSearch() {
    this.contactControl.valueChanges.pipe(
      debounceTime(500),
        // distinctUntilChanged()
    ).subscribe((suc) => {   // Getting the suggestions for the keyword/query typed in the input field.
      suc = suc.trim();
      var numberregex = /^[0-9]+$/ ;
      if(suc.length > 2 && !(suc.match(numberregex))) {
        this.getSyncedContacts(suc);
      } else {
        this.suggestedContactList = [];
      }
    })
  }

  onSearchChange(searchValue: string) {
    // if(searchValue.trim().length > 2) {
    //   this.getSyncedContacts(searchValue);
    // }
  }

  getSelectedContact(contact) {
    console.log("to compare",this.suggestedContactList)
    let currentTF = this.universalService.currentTeamFolder;
    if(this.universalService.showFeaturesForEntUsers == true  && this.universalService.isAllowEnternalPrivateShare == true || (window.location.href.includes("teamfolders") && currentTF.isAllowExtSharing == false)){
      if(this.suggestedContactList.length == 0){
        this.implRef.mailError.error = 'Enter valid enterprise user name.'
        return false
      }else{
        this.suggestedContactList.map((item)=>{
          if(item == contact){
            this.implRef.mailError.error = ''
          }else{
            this.implRef.mailError.error = 'Enter valid enterprise user name.'
            return false
          }
        })
      }
    }
    var recipient = [];
    recipient.push(contact);
    this.implRef.validateInputIds(recipient);
    if(this.universalService.isAnyChange && this.implRef.isInputValidated == true) {
      this.cleverTapEventsService.privateShareUserAdded();

      this.implRef.sharedWithNamesLink = "";
      var recipientObj = {
        "recipientId" : recipient[0],
        "recipientRole" : "V",
        "isNewRecipient" : true
      }
      this.implRef.displayList.unshift(recipientObj);

      for(var i=0;i<this.implRef.displayList.length;i++){
        this.implRef.displayList[i].recipientId = this.implRef.displayList[i].recipientId.toLowerCase();
      }
      var unique = [...new Map(this.implRef.displayList.map(item => [item['recipientId'], item])).values()];
      this.implRef.displayList = unique;
      this.universalService.isAnyChange = true;
      setTimeout(() => {
        $('#contact-input').val('');
      }, 100);
      this.implRef.isInputValidated = false;
    }
    this.suggestedContactList = [];
    if($('#manageAccess').children().hasClass("collapsed") || this.implRef.displayList.length == 1) {
      setTimeout(() => {
        $('.NeueDropdown_Inactive').click(); 
        this.setHeightForPeopleContainer();
      }, 200);
    }
  }


  setHeightForPeopleContainer(){
    setTimeout(() => {
      this.containerHeightCalc.calculateHeight('.manage-ppl-email-ids',['.pseudo-mini-thumb-details','.pseudo-card-head','.pseudo-email-chips-main','.pseudo-private-share-panel-footer'],56)
    }, 500);
  }

}
